import(/* webpackMode: "eager", webpackExports: ["LandingClient"] */ "/workspace/src/components/landing/landing-client.tsx");
